var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.37025,
    height: 58.48424999999999,
    viewBox: "-0.5051249999999996 9.937875000000005 79.37025 58.48424999999999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 39.18 39.18)",
    id: "Xd8W-4rBHf0vAedMzYXMF"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(217,42,28)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 38.86413 -20.16987 L -9.726869999999998 28.42113 C -10.154869999999999 28.849130000000002 -10.847869999999999 28.849130000000002 -11.274869999999998 28.42113 L -38.864869999999996 0.8301300000000005 C -39.291869999999996 0.4041300000000005 -39.291869999999996 -0.2888699999999995 -38.864869999999996 -0.7168699999999995 L -32.160869999999996 -7.420869999999999 C -31.732869999999995 -7.847869999999999 -31.039869999999997 -7.847869999999999 -30.612869999999994 -7.420869999999999 L -10.499869999999994 12.69113 L 5.363920000000006 -3.1726600000000005 L 30.613130000000005 -28.421870000000002 C 31.042130000000004 -28.84887 31.733130000000006 -28.84887 32.16113000000001 -28.421870000000002 L 38.86413000000001 -21.71787 C 39.29213000000001 -21.29087 39.29213000000001 -20.59887 38.86413000000001 -20.169870000000003 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.a17b62f24c0daeadc279b4022b3260a8.svg";
export { ForwardRef as ReactComponent };